export default "__VITE_ASSET__CMvTc7L$__"